<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
    </div>
    <p class="title">上海渤珺网络科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：中国（上海）自由贸易试验区临港新片区平庄东路1558号3幢</span>
      <span>Tel：17278205668</span>
    </p>
    <p class="email_wx">
      <span>邮箱：bojuntech@163.com</span>
      <span>QQ群：893844058</span>
    </p>
    <p class="beian">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010902003448" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="@/assets/img/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31010902003448号</p>
      </a>
      <a href="https://beian.miit.gov.cn" target="_blank" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪ICP备2023006613号-3.</p></a> 
    </p>
    <p class="copy"> Copyright &copy; 2023 - {{ new Date().getFullYear() }} 上海渤珺网络科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 25px;
  height: 25px;
  margin: 20px auto 20px;
}
.logo>img {
  height:25px;
  width:25px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.beian {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue